"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const castNumberToCoordinate = (value) => {
    if (!value) {
        return undefined;
    }
    if (typeof value === 'number') {
        return value;
    }
    if (/^-?[0-9]+(\.[0-9]+)?$/.test(`${value}`)) {
        return Number(Number(value).toFixed(8));
    }
    return undefined;
};
exports.default = castNumberToCoordinate;
